<template>
  <div>
      <div class="header">
        <div class="nav">
          <ul>
            <router-link to="/home"><li>首页</li></router-link>
            <router-link to="/about"><li>关于心动好物</li></router-link>
            <router-link to="/contact"><li class="navLi">联系我们</li></router-link>
            <router-link to="/charge"><li>收费资讯</li></router-link>
            <registerModule></registerModule>
          </ul>
        </div>
        <div class="contact"></div>
        <div class="information">
            <div class="item">
              <div>
                <img src="@/assets/img/customer.png" alt="">
              </div>
              <p class="infoTitle">客户服务</p>
              <p class="infoContent">电话:13651176873</p>
            </div>
            <div class="item">
              <div>
                <img src="@/assets/img/business.png" alt="">
              </div>
              <p class="infoTitle">商务合作</p>
              <p class="infoContent">邮箱:13651176873@139.com</p>
            </div>
<!--            <div class="item">-->
<!--              <div>-->
<!--                <img src="@/assets/img/human.png" alt="">-->
<!--              </div>-->
<!--              <p class="infoTitle">人力资源</p>-->
<!--              <p class="infoContent">邮箱:13651176873@139.com</p>-->
<!--            </div>-->
        </div>
      </div>
      <bottom></bottom>
  </div>
</template>

<script>
    import bottom from '@/components/bottom.vue'
    import registerModule from "@/components/registerModule.vue";

    export default {
        name: "contact",
        components:{bottom, registerModule}
    }
</script>

<style scoped>
  .header{
    height:910px;
    background:#F9F9F9;
    padding-top:25px;
    /*position:relative;*/
  }
  .nav{
    width:100%;
    height:150px;
    border: 0px solid red;
    margin:0 auto;
    background:url(../../assets/img/logoLine.png) no-repeat 230px 70px;
    background-size:268px 54px;
    padding-right:323px;
  }
  .nav ul{
    height:70px;
    display:flex;
    justify-content:flex-end;
    align-items:center;
  }
  .nav ul li{
    font-size:18px;
    color:#221815;
    font-weight:600;
    padding:13px 35px;
    margin-right:20px;
    /*margin-top:8px;*/
    font-family:'PingFang Bold';
  }
  .navLi{
    border:1px solid rgba(34, 24, 21, 0.5);
    border-radius:20px;
  }
  .contact{
    width:665px;
    height:230px;
    margin:50px auto 99px;
    background:url(../../assets/img/contact.png) no-repeat center center;
    background-size:100% 100%;
  }
  .information{
    width:1126px;
    margin:0 auto;
    display:flex;
    justify-content:space-between;
    align-items:center;
  }
  .item{
    width:100%;
    display:table-cell;
    vertical-align: middle;
    text-align: center;
    border: 0px solid red;
  }
  .item img{
    width:169px;
    height:169px;
    margin-bottom:52px;
  }
  .infoTitle{
    font-family: 'PingFang Light';
    font-weight:600;
    font-size:30px;
    color:#3B3D40;
    margin-bottom:20px;
  }
  .infoContent{
    font-family: 'PingFang Bold';
    font-size:20px;
    color:#3B3D40;
    border: 0px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/contact/contact.vue